module.exports = __webpack_public_path__ + "static/img/joinUs.14b483d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinUs.png
// module id = gQ0X
// module chunks = 62